export default __webpack_public_path__ + "static/media/nodata.0b42567d.gif";